import { render } from "./Example4.vue?vue&type=template&id=a0f66ce8"
import script from "./Example4.vue?vue&type=script&lang=ts"
export * from "./Example4.vue?vue&type=script&lang=ts"
script.render = render

export default script